import React, { useRef } from 'react';
import { getFullName, getInitials, toUserTimezone } from 'utils';
import useStyles from 'components/pages/messages/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  makeStyles,
  Box,
  Typography,
  Avatar,
} from '@material-ui/core';
import Composer from './Composer';
import { useSelector } from 'react-redux';
import {
  ADD_CONFERENCE_NOTE,
  GET_CONFERENCE_NOTES,
} from 'graphql/conference/notes';
import { useMutation, Query } from 'react-apollo';
import useSnack from 'hooks/useSnack';
import Spin from 'components/common/Spin';
import stc from 'string-to-color';

const Styles = makeStyles((theme) => ({
  card: {
    width: 400,
  },
  note: {
    marginBottom: theme.spacing(2),
  },
  footer: {},
  text: {
    paddingLeft: '4rem',
    whiteSpace: 'pre-line'
  },
  fullname: {
    paddingLeft: '1rem',
    paddingTop: 4,
  },
}));

const Note = ({ note, user }) => {
  const classesNote = Styles();
  return (
    <div className={classesNote.note}>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex">
          <Avatar
            style={{ backgroundColor: stc(note.user.user_email) }}
            src={note.user.user_pic}
          >
            {getInitials(note.user.user_first_name, note.user.user_last_name)}
          </Avatar>
          <Typography className={classesNote.fullname} variant="subtitle2">
            {getFullName(note.user)}
          </Typography>
        </Box>
        <Typography variant="caption">
          {toUserTimezone(note.created_at, user.timezone).format('LLL')}
        </Typography>
      </Box>
      <Typography className={classesNote.text} variant="body2">
        {note.text}
      </Typography>
    </div>
  );
};

const Notes = ({ confId }) => {
  const snack = useSnack();
  const listRef = useRef();
  const classes = useStyles();
  const user = useSelector((state) => state.user.user);
  const [createNote] = useMutation(ADD_CONFERENCE_NOTE);

  const addNote = async (text) => {
    try {
      return await createNote({
        variables: {
          data: {
            text,
            created_by: user.id,
            conference_id: Number(confId),
          },
        },
        update: (proxy, result) => {
            const { conferenceNotes } = proxy.readQuery({
              query: GET_CONFERENCE_NOTES,
              variables: { conferenceId: Number(confId) },
            });
            console.log(conferenceNotes,'conferenceNotes')
            conferenceNotes.push(result.data.row);
            proxy.writeQuery({
              query: GET_CONFERENCE_NOTES,
              variables: { conferenceId: Number(confId) },
              data: {
                conferenceNotes,
              },
            });
          },
      });
    } catch (e) {
      snack.error(e.message);
    }
  };

  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.header}
        avatar={''}
        titleTypographyProps={{
          style: { fontWeight: 'bold' },
        }}
        title="Comments"
        subheader={''}
        action={''}
      />
      <CardContent className={classes.messagesContainer} ref={listRef}>
        <Query
          query={GET_CONFERENCE_NOTES}
          variables={{ conferenceId: Number(confId) }}
          fetchPolicy={'cache-and-network'}
        >
          {({ data, loading }) => {
            if (loading) return <Spin spinning />;

            return (
              <CardContent>
                {data?.conferenceNotes.map((i, idx) => {
                  return <Note key={idx} note={i} user={user} />;
                })}
              </CardContent>
            );
          }}
        </Query>
      </CardContent>
      <CardActions>
        <Composer addNote={addNote} />
      </CardActions>
    </Card>
  );
};

export default Notes;
